<template>
  <el-select
    v-model="value"
    filterable
    remote
    clearable
    reserve-keyword
    placeholder="请输入关键词"
    :remote-method="remoteMethod"
    :loading="loading"
  >
    <el-option v-for="item in options" :key="item.code" :label="item.name" :value="item.code"></el-option>
  </el-select>
</template>
<script>
export default {
  name: "fuzzy-query",
  props: ["typeKey", "valueId", "option"],
  data() {
    var config = {
      storeName: { url: "getListByName", type: "store" },
      groupName: { url: "getGroupListByName", type: "customer" },
      subjectName: {url: "getSubjectListByName", type: "splitAcc"}

    };
    return {
      value: "",
      setting: config[this.typeKey],
      options: [],
      loading: false
    };
  },
  watch: {
    value: function(val) {
      this.$emit("update:valueId", val);
    },
    option: {
      immediate: true,
      handler: function(val) {
        if (val && val.length !== 0) {
          this.options = val;
          this.value = val[0].code;
        }
      }
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.query(query);
      } else {
        this.options = [];
      }
    },
    async query(val) {
      this.loading = true;
      const { url, type } = this.setting;
      var temp = {};
      temp[this.typeKey] = val;
      const { ret, data } = await _api[type][url](temp);
      if (ret && data) {
        this.options = data;
      }
      this.loading = false;
    },
    reset() {
      this.value = "";
      this.$emit("update:valueId", "");
      this.options = [];
    }
  }
};
</script>

<style>
</style>